import { useEffect, useState } from "react";
import { getAnnouncement } from "../lib/api";
import { useSocketEvent } from "../lib/socket";
import type { Announcement } from "../lib/types";

/**
 * The operator's notice, above everything else on the landing page.
 *
 * It listens for `ap:announcement` as well as fetching, so posting or retiring
 * one lands on every open page immediately — a notice that needs a refresh to
 * appear is no use on a drop day. A null payload clears it.
 */
export default function AnnouncementBanner() {
  const [announcement, setAnnouncement] = useState<Announcement | null>(null);

  useEffect(() => {
    const controller = new AbortController();
    let active = true;

    getAnnouncement(controller.signal)
      .then((next) => {
        if (active) setAnnouncement(next);
      })
      // A missing notice is the normal case, not an error worth showing.
      .catch(() => undefined);

    return () => {
      active = false;
      controller.abort();
    };
  }, []);

  useSocketEvent<Announcement | null>("ap:announcement", (next) => setAnnouncement(next ?? null));

  if (!announcement) return null;

  return (
    <div className="ap-announce" role="status">
      <span className="ap-announce__dot" aria-hidden="true" />
      <p>{announcement.message}</p>
    </div>
  );
}
